import { StreamInitConfig } from '@wix/da-shared-react/pkg/Stream/withOffset/types';
import { StreamType } from '@wix/da-shared-react/pkg/Stream';
import { fetchNextTransactionsV3 } from '../actions/points';

export const pointsTransactionsStreamConfig: StreamInitConfig = {
  streamType: StreamType.WITH_OFFSET,
  autoFetch: true,
  itemsPerFetch: 24,
  fetchNextCallback: fetchNextTransactionsV3,
};
